module.exports = __webpack_public_path__ + "static/media/cs-contact.1d1612c2.svg";